import React from 'react';
import Img from 'gatsby-image';

import './service.scss';
import { Link } from 'gatsby';

export default ({ service }) => (
  <div className="service">
    <Img fluid={service.image.fluid} />

    <div className="service__info">
      <h5 className="service__info-name">{service.name}</h5>
      <hr className="service__hr" />
      <Link className="service__info-cta" to={`/servizio/${service.slug}`}>
        <span>Scopri di più</span>
      </Link>
    </div>
  </div>
);
